import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { NavElem, NavLink } from "./nav-elem/nav-elem";
import { AppRoutes } from '../../app/app.routes';
import { AuthService } from '../../auth/auth.service';
import { environment } from '../../environments/environment';

@Component({
  selector: "app-navigation-panel",
  templateUrl: "./navigation-panel.html",
  styleUrls: ["./navigation-panel.scss"],
  imports: [
    NavElem,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationPanel {
  private authService = inject(AuthService);
  private isAdmin = !!this.authService.account()?.userHasPermission("ROLE_ADMIN");
  protected navLinks: NavLink[] = [
    {
      label: 'nav.jobOffers.title',
      routerLink: null,
      icon: 'newspaper',
      subLinks: [
        {
          label: 'nav.jobOffers.offersListing',
          routerLink: ["/", AppRoutes.jobOffers, AppRoutes.jobOffersListing],
        },
        {
          label: 'nav.jobOffers.newJobOffer',
          routerLink: ["/", AppRoutes.jobOffers, AppRoutes.newJobOffer],
        },
        {
          label: 'nav.jobOffers.jobIntegrationListing',
          routerLink: ["/", AppRoutes.jobOffers, AppRoutes.jobIntegrationListing],
          visibilityCondition: this.isAdmin,
        },
      ]
    },
    {
      label: 'nav.cms.cms',
      routerLink: null,
      icon: 'file_edit',
      visibilityCondition: this.isAdmin,
      subLinks: [
        {
          label: 'nav.cms.testimonials',
          routerLink: ["/", AppRoutes.cms, AppRoutes.testimonials],
        },
        {
          label: 'nav.cms.banner',
          routerLink: ["/", AppRoutes.cms, AppRoutes.banner],
        },
        {
          label: 'nav.cms.prize',
          routerLink: ["/", AppRoutes.cms, AppRoutes.prize],
        },
        {
          label: 'nav.cms.benefits',
          routerLink: ["/", AppRoutes.cms, AppRoutes.benefits],
        },
        {
          label: 'nav.cms.management',
          routerLink: ["/", AppRoutes.cms, AppRoutes.management],
        },
        {
          label: 'nav.cms.recruitmentTeam',
          routerLink: ["/", AppRoutes.cms, AppRoutes.recruitmentTeam],
        },
        {
          label: 'nav.cms.recruitmentSteps',
          routerLink: ["/", AppRoutes.cms, AppRoutes.recruitmentSteps],
        },
        {
          label: 'nav.cms.socialInvolvement',
          routerLink: ["/", AppRoutes.cms, AppRoutes.socialInvolvement],
        },
        {
          label: 'nav.cms.companies',
          routerLink: ["/", AppRoutes.cms, AppRoutes.companies],
        },
        {
          label: 'nav.cms.logisticCenter',
          routerLink: ["/", AppRoutes.cms, AppRoutes.logisticCenter],
        },
        {
          label: 'nav.cms.technology',
          routerLink: ["/", AppRoutes.cms, AppRoutes.technology],
        },
      ],
    },
    {
      label: 'nav.knowledgeBase.title',
      visibilityCondition: environment.knowledgeBaseEnabled,
      routerLink: ["/", AppRoutes.knowledgeBase],
      icon: 'books'
    },
  ];
}
